module.exports = __webpack_public_path__ + "05_veryshort_brown.99095e91.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/05_veryshort_brown.png
// module id = KUlP
// module chunks = 0